import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import remarkBreaks from "remark-breaks"
import remarkEmoji from "remark-emoji"
import rehypeExternalLinks from "rehype-external-links"
import { useChatStore } from "../../state/chat-store"

function isSingleEmoji(text: string): boolean {
	const trimmed = text.trim()
	const emojiRegex = /^\p{Emoji}$/u
	return emojiRegex.test(trimmed)
}

export function MessageText({ text }: { text: string }) {
	const singleEmoji = isSingleEmoji(text)
	const setActiveChannelId = useChatStore(s => s.setActiveChannelId)

	return (
		<div className={singleEmoji ? "text-5xl" : ""}>
			<ReactMarkdown
				remarkPlugins={[remarkGfm, remarkBreaks, remarkEmoji]}
				rehypePlugins={[[rehypeExternalLinks, { target: "_blank", rel: ["noopener","noreferrer","nofollow"] }]]}
				components={{
					a: ({ href, ...props }) => {
						const chatMatch = href?.match(/^\/chat\/(.+)$/)
						if (chatMatch)
							return <a {...props} href={href} className="underline" onClick={(e) => { e.preventDefault(); setActiveChannelId(chatMatch[1]) }} />
						return <a {...props} href={href} className="underline" />
					},
				}}
			>
				{text}
			</ReactMarkdown>
		</div>
	)
}